/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

const BUTTON_SIZE = 48;
const GAP = 8;

let updateFrame = null;

function getGallery() {
  return document.querySelector('.pswp');
}

function galleryIsOpen(gallery) {
  return (
    gallery &&
    (
      gallery.classList.contains('pswp--open') ||
      gallery.getAttribute('aria-hidden') === 'false'
    )
  );
}

function getActiveImage(gallery) {
  const items = Array.from(
    gallery.querySelectorAll('.pswp__item')
  );

  const viewportCenter = window.innerWidth / 2;

  let activeItem = null;
  let smallestDistance = Infinity;

  items.forEach((item) => {
    const rect = item.getBoundingClientRect();

    if (rect.width <= 0 || rect.height <= 0) return;

    const itemCenter = rect.left + rect.width / 2;
    const distance = Math.abs(itemCenter - viewportCenter);

    if (distance < smallestDistance) {
      smallestDistance = distance;
      activeItem = item;
    }
  });

  if (!activeItem) return null;

  return activeItem.querySelector(
    '.pswp__img:not(.pswp__img--placeholder)'
  );
}

function updateCloseButton() {
  const gallery = getGallery();

  if (!galleryIsOpen(gallery)) return;

  const button = gallery.querySelector('.pswp__custom-close');
  const image = getActiveImage(gallery);

  if (!button || !image) {
    updateFrame = requestAnimationFrame(updateCloseButton);
    return;
  }

  const rect = image.getBoundingClientRect();

  if (rect.width <= 0 || rect.height <= 0) {
    updateFrame = requestAnimationFrame(updateCloseButton);
    return;
  }

  const top = Math.max(GAP, rect.top + GAP);

  const left = Math.min(
    window.innerWidth - BUTTON_SIZE - GAP,
    rect.right - BUTTON_SIZE - GAP
  );

  button.style.setProperty(
    'position',
    'fixed',
    'important'
  );

  button.style.setProperty(
    'top',
    `${top}px`,
    'important'
  );

  button.style.setProperty(
    'left',
    `${left}px`,
    'important'
  );

  button.style.setProperty(
    'right',
    'auto',
    'important'
  );

  button.classList.add('zoom-close-ready');

  updateFrame = requestAnimationFrame(updateCloseButton);
}

function startCloseButton() {
  const gallery = getGallery();

  if (!galleryIsOpen(gallery)) return;

  const button = gallery.querySelector('.pswp__custom-close');

  if (button) {
    button.classList.remove('zoom-close-ready');
  }

  if (updateFrame) {
    cancelAnimationFrame(updateFrame);
  }

  updateFrame = requestAnimationFrame(updateCloseButton);
}

function stopCloseButton() {
  const gallery = getGallery();
  const button = gallery?.querySelector('.pswp__custom-close');

  if (updateFrame) {
    cancelAnimationFrame(updateFrame);
    updateFrame = null;
  }

  button?.classList.remove('zoom-close-ready');
}

const gallery = getGallery();

if (gallery) {
  const galleryObserver = new MutationObserver(() => {
    if (galleryIsOpen(gallery)) {
      startCloseButton();
    } else {
      stopCloseButton();
    }
  });

  galleryObserver.observe(gallery, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden']
  });
}

window.addEventListener('resize', startCloseButton);

window.addEventListener(
  'scroll',
  startCloseButton,
  { passive: true }
);

window.addEventListener(
  'scroll',
  startCloseButton,
  { passive: true }
);

document.addEventListener('click', function (event) {

  const gallery = document.querySelector(
    '.pswp.pswp--open, .pswp[aria-hidden="false"]'
  );

  if (!gallery || !gallery.contains(event.target)) {
    return;
  }

  const clickedImage = event.target.closest('.pswp__img');

  const clickedControl = event.target.closest(
    '.pswp__button, .pswp__thumbs, .pswp__caption'
  );

  if (clickedImage || clickedControl) {
    return;
  }

const closeButton = gallery.querySelector('.pswp__custom-close');

  if (closeButton) {
    closeButton.click();
  }

});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
function apriPopup() {
    window.open("https://www.kult.com.cy/pages/shipping", "Popup", "width=500,height=500");
  }
window.addEventListener(
  'scroll',
  () => {
    lastPosition = '';
    startZoomCloseButtonWatcher();
  },
  { passive: true }
);

